import { Env, readFromEnv } from "@cinch-nx/environments";
export var getReservationServiceUrl = function() {
    return readFromEnv(Env.ReservationServiceUrl);
};
